export default __webpack_public_path__ + "static/12-57968488d375e78a2f1d6be83784eb73.jpg";